// ----
import _ from 'lodash'
import { getVariablesInsideCurlyBrackets } from '../../../lib/storage'

const SEARCH_MODES = {
  strictEquals(property: any, searchValue: string) {
    return property === searchValue
  },

  lowercaseEquals(property: any, searchValue: string) {
    return _.isString(property) && property?.toLowerCase() === searchValue?.toLowerCase()
  },

  includes(property: any, searchValue: string) {
    return _.isString(property) && property.toLowerCase().includes(searchValue.toLowerCase())
  },

  interpolatedStorage(property: any, searchValue: string) {
    // !.includes("{") seems to speed up search in large trees by about 5% 🤷
    if (!_.isString(property) || !property.includes('{')) {
      return false
    }

    return getVariablesInsideCurlyBrackets(property).some(
      text => text.toLowerCase() === searchValue.toLowerCase()
    )
  }
} as const

type Searcher = (property: string, searchValue: string) => boolean
export type SearchMode = keyof typeof SEARCH_MODES | Searcher

export function createCompositeSearcher(query: string, modes: Array<SearchMode | Searcher>) {
  return function compositeSearcher(searched: string | string[]): boolean {
    if (_.isArray(searched)) {
      return searched.some(searched => compositeSearcher(searched))
    }

    if (!_.isString(searched)) {
      return false
    }

    return modes.some(mode =>
      _.isFunction(mode) ? mode(searched, query) : SEARCH_MODES[mode]?.(searched, query)
    )
  }
}
